import Beacon from "@/frontend/modules/beacon/beacon";

(async () => {
    const beacon = new Beacon({
        beamIntervalMs: 30_000,
    });

    await beacon.create();
})();
